import { useEffect } from "react";
import { NetworkStatus } from "@apollo/client";

// Apollo only reports `refetch` for an explicit .refetch() call (e.g. usePollingManagement's
// reactivation resync) - regular polling reports `poll`, so this never fires on a poll tick.
const useResumeInfiniteScrollOnRefetch = (networkStatus: NetworkStatus, onRefetch: () => void) => {
  useEffect(() => {
    if (networkStatus === NetworkStatus.refetch) {
      onRefetch();
    }
  }, [networkStatus, onRefetch]);
};

export default useResumeInfiniteScrollOnRefetch;
